import { render, staticRenderFns } from "./EntityHistory.component.vue?vue&type=template&id=d5b0cab4&scoped=true&"
import script from "./EntityHistory.component.vue?vue&type=script&lang=js&"
export * from "./EntityHistory.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b0cab4",
  null
  
)

export default component.exports